import { request, getCompanyId } from '../utils';
import {
  API_OHC_UTILIZATION,
  API_CONTRACTS,
  API_ACTIVITY_LOG_DOWNLOAD,
  API_ACTIVITY_LOG,
  API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG,
  API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG_DOWNLOAD,
  API_PHARMACY_ACTIVITY_LOG_DOWNLOAD,
  API_CONSULTATION_ACTIVITY_LOG_DOWNLOAD,
  API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG_FILTERS,
  API_PHARMACY_ACTIVITY_LOG_FILTERS,
  API_CONSULTATION_ACTIVITY_LOG_FILTERS,
  API_COMMON_AHC_DENTAL_VISION_FETCH_PACKAGES,
  API_COMMON_AHC_DENTAL_VISION_METRICS,
  API_COMMON_AHC_DENTAL_VISION_RATINGS_AND_OPTIONS,
  API_COMMON_AHC_DENTAL_VISION_UTILIZATION,
  API_COMMON_AHC_DENTAL_VISION_COST_UTILIZATION,
  API_COMMON_AHC_DENTAL_VISION_OVERALL,
  API_COMMON_AHC_DENTAL_VISION_OVERALL_RATINGS,
  API_COMMON_AHC_DENTAL_VISION_OVERALL_SAVINGS,
  API_COMMON_AHC_DENTAL_VISION_OVERALL_NETWORK,
  API_DOCTOR_CONSULTAION_METRICS,
  API_DOCTOR_CONSULTAION_USERS,
  API_DOCTOR_CONSULTAION_RATINGS,
  API_DOCTOR_CONSULTAION_COVERAGE,
  API_DOCTOR_CONSULTAION_OVERALL,
  API_DOCTOR_CONSULTAION_OVERALL_AVGWAIT_TIME,
  API_DOCTOR_CONSULTAION_OVERALL_REPEATEDUSERS,
  API_DOCTOR_CONSULTAION_OVERALLRATINGS,
  API_FITNESS_METRICS,
  API_FITNESS_COMMENTS,
  API_FITNESS_RATINGS,
  API_FITNESS_UTILIZATION,
  API_HEALTH_COACH_METRICS,
  API_HEALTH_COACH_MEDICAL,
  API_HRA_METRICS,
  API_HRA_UTILIZATION,
  API_PHARMACY_METRICS,
  API_PHARMACY_RATINGS,
  API_PHARMACY_SPENDINGS,
  API_PHARMACY_COVERAGE,
  API_VACCINATION_METRICS,
  API_VACCINATION_RATINGS,
  API_VACCINATION_UTILIZATION,
  API_VACCINATION_FUTURE_APPOINTMENTS,
  API_VACCINATION_OVERALL,
  API_VACCINATION_OVERALL_RATINGS,
  API_VACCINATION_OVERALL_SAVINGS,
  API_VACCINATION_OVERALL_NETWORK,
  API_SPENDING_ACCOUNT_UTILIZATION,
  API_SPENDING_ACCOUNT_DATA,
  API_SPENDING_ACCOUNT_RATINGS,
  API_NETWORK_VIEWPAGE,
  API_HOME_COLLECTION_LIST,
  API_PACKAGE_DESCRIPTION,
  API_NETWORK_CITYLIST,
  API_ENTERPRISE_LIST,
  API_FETCH_DOWNLOAD_NETWORK_PROVIDERS,
  API_DOWNLOAD_NETWORK_PROVIDERS,
  API_UTILIZATION_BENEFIT_LISTS,
  API_WALLET_UTILIZATION,
  API_DOCTOR_CONSULTAION_UTILIZATION
} from '../routes/api';

class utilizationApi {
  static fetchContracts(options, onSuccess, onError) {
    const params = options?.params || {};
    const companyVal = params.company_id ?? params.sids ?? params.sid;
    if (companyVal != null && companyVal !== '') {
      const url = `${API_CONTRACTS}?${getCompanyId(true, companyVal)}`;
      const { params: _p, ...rest } = options || {};
      return request({ url, method: 'get', ...rest }, onSuccess, onError);
    }
    return request({ url: API_CONTRACTS + '?' + getCompanyId(true), method: 'get', ...options }, onSuccess, onError);
  }

  static fetchActivityLog(options, onSuccess, onError) {
    return request(
      { url: API_ACTIVITY_LOG(options.startDate, options.endDate, options.str, options.page, options.contractId) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static downloadActivityLog(options, onSuccess, onError) {
    return request(
      {
        url: API_ACTIVITY_LOG_DOWNLOAD(options.str, options.startDate, options.endDate, options.contractId) + '&' + getCompanyId(true),
        method: 'get', ...options
      },
      onSuccess,
      onError
    );
  }

  static fetchCommonAhcDentalVisionActivityLog(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG(options.startDate, options.endDate, options.str, options.page, options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fetchCommonAhcDentalVisionActivityLogFilters(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG_FILTERS(options.startDate, options.endDate, options.page, options.contractId, options.benefit_type, options.filters) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fetchPharmacyActivityLogFilters(options, onSuccess, onError) {
    return request(
      { url: API_PHARMACY_ACTIVITY_LOG_FILTERS(options.startDate, options.endDate, options.page, options.contractId, options.benefit_type, options.filters) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fetchConsultationActivityLogFilters(options, onSuccess, onError) {
    return request(
      { url: API_CONSULTATION_ACTIVITY_LOG_FILTERS(options.startDate, options.endDate, options.page, options.contractId, options.benefit_type, options.filters) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fetchCommonAhcDentalVisionFetchPackages(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_FETCH_PACKAGES(options.startDate, options.endDate, options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static downloadCommonAhcDentalVisionActivityLog(options, onSuccess, onError) {
    return request(
      {
        url: API_COMMON_AHC_DENTAL_VISION_ACTIVITY_LOG_DOWNLOAD(options.str, options.startDate, options.endDate, options.contractId, options.benefit_type, options.filters) + '&' + getCompanyId(true),
        method: 'get', ...options
      },
      onSuccess,
      onError
    );
  }

  static downloadPharmacyActivityLog(options, onSuccess, onError) {
    return request(
      {
        url: API_PHARMACY_ACTIVITY_LOG_DOWNLOAD(options.startDate, options.endDate, options.contractId) + '&' + getCompanyId(true),
        method: 'get', ...options
      },
      onSuccess,
      onError
    );
  }

  static downloadConsultationActivityLog(options, onSuccess, onError) {
    return request(
      {
        url: API_CONSULTATION_ACTIVITY_LOG_DOWNLOAD(options.startDate, options.endDate, options.contractId, options.filters) + '&' + getCompanyId(true),
        method: 'get', ...options
      },
      onSuccess,
      onError
    );
  }

  static commonFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_METRICS(options.startDate, options.endDate, options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }
  
  static walletBenefitUtilization(options, onSuccess, onError) {
    return request(
      { url: API_WALLET_UTILIZATION(options.startDate, options.endDate, options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static commonFetchRatingsAndOptions(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_RATINGS_AND_OPTIONS(options.startDate, options.endDate, options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static commonFetchUtilizationGraph(options, onSuccess, onError) {
    return request(
      {
        url: API_COMMON_AHC_DENTAL_VISION_UTILIZATION(options.startDate, options.endDate, options.filter, options.contractId, options.benefit_type) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static fetchUtilizationBenefitList(options, onSuccess, onError) {
    const { companyId, sids, sid, contractId, misPulse, params: inputParams, ...axiosOptions } = options || {};
    const sidVal = sids ?? sid;
    const query =
      sidVal != null && sidVal !== ''
        ? getCompanyId(true, sidVal)
        : getCompanyId(true, companyId);
    const params = { ...(inputParams || {}) };
    if (contractId != null && contractId !== '') {
      params.contract_id = contractId;
    }
    if (misPulse) {
      params.mis_pulse = true;
    }
    return request(
      {
        url: API_UTILIZATION_BENEFIT_LISTS(query),
        method: 'get',
        ...axiosOptions,
        ...(Object.keys(params).length ? { params } : {}),
      },
      onSuccess,
      onError
    );
  }

  static commonFetchCostSavingDetails(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_COST_UTILIZATION(options.startDate, options.endDate, options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static commonFetchOverall(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_OVERALL(options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static commonFetchOverallRatings(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_OVERALL_RATINGS(options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static commonFetchOverallSavings(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_OVERALL_SAVINGS(options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static commonFetchOverallNetwork(options, onSuccess, onError) {
    return request(
      { url: API_COMMON_AHC_DENTAL_VISION_OVERALL_NETWORK(options.contractId, options.benefit_type) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  /** The one-page OHC report: { enabled, metrics, text } */
  static ohcFetchPage(options, onSuccess, onError) {
    return request(
      { url: API_OHC_UTILIZATION('page', options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  /** One page of the OHC activity log: { rows, total, per_page, filter_options }. filters: { site, visit_type, health_issue, employee_type, employee_id } */
  static ohcActivityLog(options, onSuccess, onError) {
    const query = `&page=${options.page}&filters=${encodeURIComponent(JSON.stringify(options.filters || {}))}`;
    return request(
      { url: API_OHC_UTILIZATION('activity_log', options.contractId, options.startDate, options.endDate) + query + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  /** Emails the whole OHC activity log, with the same filters, as Excel */
  static ohcActivityLogDownload(options, onSuccess, onError) {
    const query = `&filters=${encodeURIComponent(JSON.stringify(options.filters || {}))}`;
    return request(
      { url: API_OHC_UTILIZATION('activity_log_download', options.contractId, options.startDate, options.endDate) + query + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  /** The same OHC page as a PDF file (binary, so responseType blob). */
  static ohcDownloadReport(options, onSuccess, onError) {
    return request(
      { url: API_OHC_UTILIZATION('download', options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', responseType: 'blob', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_DOCTOR_CONSULTAION_METRICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchUsers(options, onSuccess, onError) {
    return request(
      { url: API_DOCTOR_CONSULTAION_USERS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchRatings(options, onSuccess, onError) {
    return request(
      { url: API_DOCTOR_CONSULTAION_RATINGS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchCoverage(options, onSuccess, onError) {
    return request(
      { url: API_DOCTOR_CONSULTAION_COVERAGE(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchUtilization(options, onSuccess, onError) {
    return request(
      { url: API_DOCTOR_CONSULTAION_UTILIZATION(options.contractId, options.startDate, options.endDate, options.filter) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchOverall(options, onSuccess, onError) {
    return request(
      { url: API_DOCTOR_CONSULTAION_OVERALL(options.contractId) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static doctorFetchOverallAvgWaitTime(options, onSuccess, onError) {
    return request(
      {
        url: API_DOCTOR_CONSULTAION_OVERALL_AVGWAIT_TIME(options.contractId) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static doctorFetchOverallRepeatedUsers(options, onSuccess, onError) {
    return request(
      {
        url: API_DOCTOR_CONSULTAION_OVERALL_REPEATEDUSERS(options.contractId) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static doctorFetchOverallRatings(options, onSuccess, onError) {
    return request(
      {
        url: API_DOCTOR_CONSULTAION_OVERALLRATINGS(options.contractId) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static fitnessFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_FITNESS_METRICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fitnessFetchComments(options, onSuccess, onError) {
    return request(
      { url: API_FITNESS_COMMENTS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fitnessFetchRatings(options, onSuccess, onError) {
    return request(
      { url: API_FITNESS_RATINGS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static fitnessFetchUtilization(options, onSuccess, onError) {
    return request(
      { url: API_FITNESS_UTILIZATION(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static healthCoachFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_HEALTH_COACH_METRICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static healthCoachFetchMedicalData(options, onSuccess, onError) {
    return request(
      { url: API_HEALTH_COACH_MEDICAL(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static hraFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_HRA_METRICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static hraFetchUtilizationGraph(options, onSuccess, onError) {
    return request(
      {
        url: API_HRA_UTILIZATION(options.contractId, options.startDate, options.endDate, options.filter) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static pharmacyFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_PHARMACY_METRICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static pharmacyFetchRatings(options, onSuccess, onError) {
    return request(
      { url: API_PHARMACY_RATINGS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static pharmacyFetchSpendings(options, onSuccess, onError) {
    return request(
      { url: API_PHARMACY_SPENDINGS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static pharmacyFetchCoverage(options, onSuccess, onError) {
    return request(
      { url: API_PHARMACY_COVERAGE(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchMetrics(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_METRICS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchRatings(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_RATINGS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchUtilizationGraph(options, onSuccess, onError) {
    return request(
      {
        url: API_VACCINATION_UTILIZATION(options.contractId, options.filter, options.startDate, options.endDate) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchFutureAppointments(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_FUTURE_APPOINTMENTS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  //overall Vaccination  
  static vaccinationFetchOverall(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_OVERALL(options.contractId) + '&' + getCompanyId(true) , method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchOverallRatings(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_OVERALL_RATINGS(options.contractId) + '&' + getCompanyId(true) , method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchOverallSavings(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_OVERALL_SAVINGS(options.contractId) + '&' + getCompanyId(true) , method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static vaccinationFetchOverallNetwork(options, onSuccess, onError) {
    return request(
      { url: API_VACCINATION_OVERALL_NETWORK(options.contractId) + '&' + getCompanyId(true) , method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  // API_SPENDING_ACCOUNT_DATA
  static spendingAccountFetchData (options, onSuccess, onError) {
    return request(
      {
        url: API_SPENDING_ACCOUNT_DATA(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static spendingAccountFetchUtilizationGraph(options, onSuccess, onError) {
    return request(
      {
        url: API_SPENDING_ACCOUNT_UTILIZATION(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true),
        method: 'get',
        ...options,
      },
      onSuccess,
      onError
    );
  }

  static spendingAccountFetchRatings(options, onSuccess, onError) {
    return request(
      { url: API_SPENDING_ACCOUNT_RATINGS(options.contractId, options.startDate, options.endDate) + '&' + getCompanyId(true), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static healthChecksFetchView(options, onSuccess, onError) {
    return request(
      { url: API_NETWORK_VIEWPAGE(options), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static healthChecksHomeCollectionView(options, onSuccess, onError) {
    return request(
      {url: API_HOME_COLLECTION_LIST(options), method: 'get', ...options }, 
      onSuccess,
       onError
    )
  }

  static networkCityList(options, onSuccess, onError) {
    return request(
      {url: API_NETWORK_CITYLIST(options), method: 'get', ...options }, 
      onSuccess,
       onError
    )
  }

  static benefitPackageDescription(options, onSuccess, onError) {
    return request(
      {url: API_PACKAGE_DESCRIPTION(options), method: 'get', ...options }, 
      onSuccess,
       onError
    )
  }

  static networkEnterpriseList(options, onSuccess, onError) {
    return request(
      {url: API_ENTERPRISE_LIST(options), method: 'get', ...options }, 
      onSuccess,
       onError
    )
  }

  static fetchDataForDownloadNetworkProviders(options, onSuccess, onError) {
    return request(
      { url: API_FETCH_DOWNLOAD_NETWORK_PROVIDERS(options.id), method: 'get', ...options },
      onSuccess,
      onError
    );
  }

  static downloadNetworkProviders(options, onSuccess, onError) {
    return request(
      { url: API_DOWNLOAD_NETWORK_PROVIDERS(options.id), method: 'get', ...options },
      onSuccess,
      onError
    );
  }
}

export default utilizationApi;